import { render, staticRenderFns } from "./salesPartNumber.vue?vue&type=template&id=2e467ada&scoped=true&"
import script from "./salesPartNumber.vue?vue&type=script&lang=js&"
export * from "./salesPartNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e467ada",
  null
  
)

export default component.exports